import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import { SELECTED_BOARD, STATUSES } from "@Broker/@Modules/clients/board/store/board-getters";
import ClientBoardDynamicLoader from "./client-board-dynamic-loader";
import StatusColumn from "./board-columns/status-column.vue";
import AddActivityNoteModal from "../../modals/add-activity-note-modal";
import { dragscroll } from "vue-dragscroll";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientBoardDynamicContainer",
  components: {
    ClientBoardDynamicLoader,
    StatusColumn,
    AddActivityNoteModal
  },
  directives: {
    dragscroll
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters("BoardStore", [SELECTED_BOARD, STATUSES])), mapState("BoardStore", ["selectedBoardId", "boardsStatusesTranslationMap"])), {}, {
    loadingStatuses() {
      return !this.orderedStatuses || this.orderedStatuses.length === 0;
    },
    showLoader() {
      return this.loading || this.loadingStatuses;
    },
    orderedStatuses() {
      const {
        STATUSES,
        SELECTED_BOARD = {}
      } = this;
      const {
        order
      } = SELECTED_BOARD;
      if (!order || isEmpty(STATUSES.byId)) return [];
      return _mapInstanceProperty(order).call(order, id => {
        var _this$$options$filter;
        const status = STATUSES.byId[id];
        return _objectSpread(_objectSpread({}, status), {}, {
          label: (_this$$options$filter = this.$options.filters.getSchemaTranslation(status.label, this.boardsStatusesTranslationMap[this.selectedBoardId])) != null ? _this$$options$filter : status.label
        });
      });
    }
  })
});